// Feature flags — single switch points, so temporary UI toggles are trivially reversible.
//
// CYCLING_ENABLED: the app supports running + cycling, but cycling is HIDDEN from the UI while we
// finish and verify the running experience (2026-07-20). Backend cycling logic is untouched — flip
// this to `true` to restore every cycling UI surface (sport pickers, tabs, profile fields, the
// home cycling tile, the activity-list cycling filter, and the coach-dashboard cycling controls).
export const CYCLING_ENABLED = false;

// GARMIN_ENABLED: Garmin via Stridee (2026-10-09). The Garmin card renders only for users the BACKEND reports
// as eligible (GARMIN_ENABLED + since 2026-10-18 every APPROVED RitmoIQ user); everyone else gets nothing. Garmin activities are NOT shown in Home /
// History / Coach chat / Insights.
export const GARMIN_ENABLED = true;

// Strava removed (C2, 2026-10-21): RitmoIQ is Garmin-only; there is no Strava UI switch any more.

// GOOGLE_SIGNIN_ENABLED: "המשך עם Google" on the login / registration screen (Phase 1, 2026-10-20, popup only). OFF
// unless the build sets REACT_APP_GOOGLE_SIGNIN_ENABLED=true — set ONLY in the isolated Vercel Preview environment
// until approved for production. Email / password sign-in, registration and reset are unchanged either way.
export const GOOGLE_SIGNIN_ENABLED = process.env.REACT_APP_GOOGLE_SIGNIN_ENABLED === 'true';

// PREMIUM_TODAY_ENABLED: the "Premium 1 · Today" Home redesign (2026-10-23, visual only — same APIs, no AI calls on
// open / refresh). OFF unless the build sets REACT_APP_PREMIUM_TODAY=true; the previous Home renders otherwise and
// stays in App.js for rollback.
export const PREMIUM_TODAY_ENABLED = process.env.REACT_APP_PREMIUM_TODAY === 'true';

// HOME_GRAPHITE_ENABLED: the "Graphite + Lime" Home (2026-10-27) + the shared 5-tab bottom bar (בית · תכנית · מאמן ·
// אימונים · פרופיל). ON by default; REACT_APP_HOME_GRAPHITE=false brings back the previous Home (rollback without a
// code change). Home only: the other screens keep their look. No AI call on Home load.
export const HOME_GRAPHITE_ENABLED = process.env.REACT_APP_HOME_GRAPHITE !== 'false';
